import {
  Button,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './ButtonSelector.scss';

/**
 * Radio buttons with button selection style that
 * allow the user to select one option from a set
 *
 * @param props of array of config object. An example is
 * config: [
 *  {
 *    label: 'Build A Book',
 *    onClick: () => { },
 *    dataValue: 'buildABook',
 *  },
 *  {
 *    label: 'Matching',
 *    onClick: () => { },
 *    dataValue: 'matching',
 *    disabled: true,
 *  },
 * ]
 *
 */
const defaultProps = {
  config: [],
  selectedValue: null,
  onSelect: () => {},
  alignment: 'horizental',
  className: '',
};
export default function ButtonSelector(props) {
  const {
    config,
    selectedValue,
    onSelect,
    alignment,
    className,
  } = { ...defaultProps, ...filterUndefined(props) };
  const handleOnClick = (dataValue) => {
    if (dataValue === selectedValue) {
      return;
    }

    onSelect(dataValue);
  };

  const alignmentClass = {
    horizental: 'button-selector-component-horizental',
    vertical: 'button-selector-component-vertical',
  };

  return (
    <div className={`${alignmentClass[alignment]} ${className}`}>
      {config.map((c, index) => (
        <Button
          data-test={`button-${c.dataValue}`}
          key={c.dataValue}
          disabled={c.disabled}
          onClick={() => handleOnClick(c.dataValue)}
          variant='contained'
          className={`vizzle-selector-${index} button-selector btn-primary ${selectedValue === c.dataValue ? 'btn-selected' : ''}`}
        >
          {c.label}
        </Button>
      ))}
    </div>
  );
}
